import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "name" }
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = { for: "name" }
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = { for: "name" }
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = { for: "name" }
const _hoisted_27 = { class: "card-footer text-center" }
const _hoisted_28 = { class: "btn-group" }
const _hoisted_29 = {
  key: 0,
  class: "card card-success card-outline"
}
const _hoisted_30 = { class: "card-header" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }, null, -1)
const _hoisted_33 = { class: "card-body row body-table-list" }
const _hoisted_34 = { class: "form-group col-12 col-md-6" }
const _hoisted_35 = { for: "name" }
const _hoisted_36 = { class: "form-group col-12 col-md-6" }
const _hoisted_37 = { for: "name" }
const _hoisted_38 = { class: "form-group col-12 col-md-6" }
const _hoisted_39 = { for: "name" }
const _hoisted_40 = { class: "form-group col-12 col-md-6" }
const _hoisted_41 = { for: "name" }
const _hoisted_42 = { class: "form-group col-12 col-md-6" }
const _hoisted_43 = { for: "name" }
const _hoisted_44 = { class: "form-group col-12 col-md-6" }
const _hoisted_45 = { for: "name" }
const _hoisted_46 = { class: "form-group col-12" }
const _hoisted_47 = { for: "name" }
const _hoisted_48 = { class: "card card-success card-outline" }
const _hoisted_49 = { class: "card-header" }
const _hoisted_50 = { class: "card-title" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }, null, -1)
const _hoisted_52 = { class: "card-body row body-table-list" }
const _hoisted_53 = {
  class: "table-list",
  style: {"width":"-webkit-fill-available"},
  cellpadding: "3"
}
const _hoisted_54 = { style: {"width":"100px"} }
const _hoisted_55 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_56 = { class: "modal-dialog" }
const _hoisted_57 = { class: "modal-content bg-danger" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = { class: "modal-title" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = { class: "modal-footer justify-content-between" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.order")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.order")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.page.order")) + " | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.entity.customer")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.customer ? _ctx.row.customer.name : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("labels.entity.amount")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.amount ? _ctx.formatNumber(_ctx.row.amount) : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("labels.entity.expireIn")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.expire_in ? _ctx.formatDate(_ctx.row.expire_in) : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("labels.entity.status")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.status === 'Confirmed',
            'bg-info': _ctx.row.status === 'PendingPayment',
            'bg-primary': _ctx.row.status === 'AwaitingPaymentConfirmation',
            'bg-warning': _ctx.row.status === 'FailedPayment',
            'bg-danger': _ctx.row.status === 'Canceled'
          }])
              }, _toDisplayString(_ctx.$t(`labels.order.status.${_ctx.row.status.charAt(0).toLowerCase() + _ctx.row.status.slice(1)}`)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-sm btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.goBack")), 1),
              (_ctx.hasPermission('edit') && (['PendingPayment', 'AwaitingPaymentConfirmation'].includes(_ctx.row.status)))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    id: "cancelButton",
                    class: "btn btn-sm btn-danger",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.cancelOrder(_ctx.row.customer.name)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.cancelOrder")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.row.payment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("h3", _hoisted_31, [
                  _hoisted_32,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.page.payment")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("labels.entity.id")) + ":    ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.row.payment.id), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("labels.entity.succeed")) + ":    ", 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.payment.succeed,
            'bg-danger': !_ctx.row.payment.succeed
            }])
                  }, _toDisplayString(_ctx.row.payment.succeed ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("labels.entity.amount")) + ":    ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatNumber(_ctx.row.payment.amount)), 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("labels.entity.type")) + ":    ", 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.payment.type === 1,
            'bg-warning': _ctx.row.payment.type === 2
          }])
                  }, _toDisplayString(_ctx.row.payment.type === 1 ? _ctx.$t('labels.paymentType.type.stripe') : _ctx.$t('labels.paymentType.type.paypal')), 3)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("labels.entity.transactionCode")) + ":    ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.row.payment.transaction_code), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("labels.entity.transactionDate")) + ":    ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.row.payment.transaction_date ? _ctx.formatDate(_ctx.row.payment.transaction_date) : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("labels.entity.result")) + ":    ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.row.payment.payment_attempt.result), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("h3", _hoisted_50, [
              _hoisted_51,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.page.orderItem")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("table", _hoisted_53, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t("labels.entity.id")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.page.product")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.amount")), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.items, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(i.id), 1),
                  _createElementVNode("td", null, _toDisplayString(i.product?.video_display_name || '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatNumber(i.amount)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      (_ctx.showCancelOrder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("h4", _hoisted_59, _toDisplayString(_ctx.$t("labels.page.cancelOrder")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Fechar",
                    onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _hoisted_61)
                ]),
                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.msgCancelOrder), 1),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.close")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.confirmCancel && _ctx.confirmCancel(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.confirm")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}